'use client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useEffect, useCallback, useRef } from 'react';

const RECAPTCHA_EVENT_LIST = ['mousemove', 'mousedown', 'keydown', 'touchstart'];

export const GoogleRecaptchaWrapper = (props: any) => {
    const { children } = props;
    const isInitialized = useRef(false);
    const scriptPreloaded = useRef(false);
    // const [shouldLoadRecaptcha, setShouldLoadRecaptcha] = useState(false);
    const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

    // Preload ReCAPTCHA script on first user interaction for faster loading
    const preloadRecaptchaScript = useCallback(() => {
        if (scriptPreloaded.current || !recaptchaKey) return;

        scriptPreloaded.current = true;

        // Create DNS prefetch for faster connection
        const dnsPrefetch = document.createElement('link');
        dnsPrefetch.rel = 'dns-prefetch';
        dnsPrefetch.href = 'https://www.google.com';
        document.head.appendChild(dnsPrefetch);

        // Preload the script for instant availability
        const preloadLink = document.createElement('link');
        preloadLink.rel = 'preload';
        preloadLink.href = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
    }, [recaptchaKey]);

    const initRecaptcha = useCallback(() => {
        if (isInitialized.current || !recaptchaKey) return;

        isInitialized.current = true;
        RECAPTCHA_EVENT_LIST.forEach((ev) => document.removeEventListener(ev, initRecaptcha));

        // Preload script first for faster subsequent loading
        preloadRecaptchaScript();

        // Enable ReCAPTCHA loading immediately after preload
        // setShouldLoadRecaptcha(true);
    }, [recaptchaKey, preloadRecaptchaScript]);

    useEffect(() => {
        if (isInitialized.current || !recaptchaKey) return;

        RECAPTCHA_EVENT_LIST.forEach((ev) => document.addEventListener(ev, initRecaptcha));

        return () => {
            RECAPTCHA_EVENT_LIST.forEach((ev) => document.removeEventListener(ev, initRecaptcha));
        };
    }, [initRecaptcha, recaptchaKey]);

    // // Memoize wrapper props to prevent unnecessary re-renders
    // const wrapperProps = useMemo(
    //     () => ({
    //         reCaptchaKey: shouldLoadRecaptcha ? recaptchaKey || '' : '',
    //         scriptProps: {
    //             defer: false, // Load immediately when needed for faster appearance
    //             async: true,
    //             id: 'recaptcha-script',
    //         },
    //     }),
    //     [recaptchaKey, shouldLoadRecaptcha],
    // );

    // Always render the same component structure to prevent remounting
    return <GoogleReCaptchaProvider
    reCaptchaKey={recaptchaKey || ''}
            scriptProps={{
                defer: false, // Load immediately when needed for faster appearance
                async: true,
                id: 'recaptcha-script',
            }}
    >{children}</GoogleReCaptchaProvider>;
};
